import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import {
  RowLeft,
} from '../Styles';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import CheckLoading from '../components/Loading/CheckLoading';
import { AiTopic } from '../../../../../lib/types/AiTypes';
import RobotReply from '../components/Reply/RobotReply';
import UserReply from '../components/Reply/UserReply';
import OptionButton from '../components/Button/OptionButton';
import DeliveryTimeInput from '../components/Input/DeliveryTimeInput';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import LeftToRight from '../components/Animation/LeftToRight';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import Q7 from '../Q7';
import Q9 from '../Q9';
import Q11 from '../Q11';
import Q15 from '../Q15';
import Q18 from '../Q18';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 没有取餐时间
 */
const Q5: FC<Props> = ({
  cabId,
  h5Platform,
  addElement,
  setTargetPage,
  driverPhone,
  deviceCode,
  sessionId,
  roomNo,
  enterPhoneNumber,
}) => {
  // 选项
  const options: {key: string; zhValue: string; enValue: string}[] = [
    { key: 'deliveryTimeInput', zhValue: 'InputBox', enValue: 'InputBox' },
    { key: '11', zhValue: '我不知道送达时间', enValue: 'I don’t know the time' },
  ];
  // 把选项发送给后台
  const [getH5OrderBoxListByDeliveryTime] = getFoodifoxDataLazy<AiTopic>('/fox3PDAi/getH5OrderBoxListByDeliveryTime');

  /**
   * 尝试次数增加时，自动追加节点
   */
  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '请输入您收到订单已送达的时间。';
    const langEn = 'Please enter the time you received the notification that your order was delivered.';

    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.58) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q5 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          {
            options.map(({ key, zhValue, enValue }) => {
              if (key === 'deliveryTimeInput') {
                return (
                  <RowLeft key={key + '' + (new Date().getTime())}>
                    <DeliveryTimeInput
                      flowId={flowId}
                      callback={(datetime) => {
                        const formatTime = moment(datetime).format('DD/MM/YYYY HH:mm');
                        addSystemLog(cabId, deviceCode, h5Platform + '', 'Q5 - user: ' + datetime, sessionId);
                        addElement(
                          <UserReply
                            langZh={formatTime}
                            langEn={formatTime}
                          />
                        );
                        send(datetime);
                      }}
                    />
                  </RowLeft>
                );
              }
              else {
                return (
                  <RowLeft key={key + '' + (new Date().getTime())}>
                    <OptionButton
                      langZh={zhValue}
                      langEn={enValue}
                      flowId={flowId}
                      callback={() => {
                        addSystemLog(cabId, deviceCode, h5Platform + '', 'Q5 - user: ' + enValue, sessionId);
                        addElement(
                          <UserReply
                            langZh={zhValue}
                            langEn={enValue}
                          />
                        );
                        addElement(
                          <Q11
                            cabId={cabId}
                            addElement={addElement}
                            h5Platform={h5Platform}
                            deviceCode={deviceCode}
                            sessionId={sessionId}
                          />
                        );
                      }}
                    />
                  </RowLeft>
                );
              }
            })
          }
        </LeftToRight>
      );
    }, 400);
  }, []);

  /**
   * 发送选项给后台
   * @param datetime 输入的取餐时间
   */
  const send = (datetime?: string) => {
    const loadingFlowId = uuid();
    addElement(
      <CheckLoading
        flowId={loadingFlowId}
        zhText={'请稍等…正在查询订单…'}
        enText={'Please wait…We are confirming details.'}
        style={{ maxWidth: lang('80%', '100%') }}
      />
    );

    getH5OrderBoxListByDeliveryTime({
      param: {
        deliverDate: datetime,
        useCabId: cabId,
        roomNo,
        driverPhoneNumber: driverPhone,
      },
      onCompleted({ boxNumberList: boxList, boxOfflineCode }) {
        setTimeout(() => {
          if (!((boxList || []).length > 0 || (boxOfflineCode || []).length > 0)) {
            // 隐藏loading
            TempFieldUtils.aiFlowIds.push(loadingFlowId);
          }
        }, 2000);
        setTimeout(() => {
          if ((boxList || []).length === 1 || (boxOfflineCode || []).length === 1) {
            if ((boxList || []).length > 0 && (boxOfflineCode || []).length === 0) {
              addElement(
                <Q7
                  boxList={boxList || []}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  cabId={cabId}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  loadingFlowId={loadingFlowId}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
            else {
              addElement(
                <Q9
                  cabId={cabId}
                  boxList={boxList || []}
                  boxOfflineCode={boxOfflineCode || []}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
          }
          else if ((boxList || []).length > 1 || (boxOfflineCode || []).length > 1) {
            if ((boxList || []).length > 0 && (boxOfflineCode || []).length === 0) {
              addElement(
                <Q15
                  cabId={cabId}
                  setTargetPage={setTargetPage}
                  boxList={boxList}
                  addElement={addElement}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  loadingFlowId={loadingFlowId}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
            else {
              addElement(
                <Q18
                  cabId={cabId}
                  addElement={addElement}
                  h5Platform={h5Platform}
                  deviceCode={deviceCode}
                  sessionId={sessionId}
                />
              );
            }
          }
          else {
            addElement(
              <Q11
                cabId={cabId}
                addElement={addElement}
                h5Platform={h5Platform}
                deviceCode={deviceCode}
                sessionId={sessionId}
              />
            );
          }
        }, 2200);
      },
    });
  };

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  h5Platform: number;
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  driverPhone?: string;
  deviceCode: string;
  sessionId: string;
  roomNo?: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q5;
